<template>
  <div id="solicitacao-detalhe">
    <div
      v-if="data"
      id="func-detalhes"
      class="func-detalhe"
    >
      <el-row
        style="padding: 30px 0;"
      >
        <el-col
          :span="14"
          class="func-infos"
        >
          <div class="border"></div>
          <StatusCard
            :cor="data.status_cor"
            disabled
            style="width: 100%; margin-bottom: 15px;"
          >
            <div class="func-status-card">
              <div class="func-status-card-titulo">
                {{ data.assunto }}
              </div>
              <div class="func-status-card-content">
                <div class="form-status-card-info">
                  <div class="func-status-card-label">
                    Situação
                  </div>
                  <div
                    :style="{'color': data.status_cor}"
                    class="func-status-card-valor"
                    style="font-weight: 600"
                  >
                    {{ data.status_label }}
                  </div>
                </div>
                <div class="form-status-card-info">
                  <div class="func-status-card-label">
                    Data solic.
                  </div>
                  <div class="func-status-card-valor">
                    {{ dataSolicitacao }}
                  </div>
                </div>
              </div>
            </div>
          </StatusCard>
          <el-tabs v-model="activeTab">
            <el-tab-pane label="Dados do Pedido" name="dados">
              <StatusCard
                disabled
                style="width: 100%;"
              >
                <div class="func-status-card">
                  <div class="func-status-card-beneficiario">
                    <div
                      style="flex: 1;"
                    >
                      <div class="func-status-card-label">
                        BENEFICIÁRIO:
                      </div>
                      <div
                        class="func-status-card-valor"
                        style="font-weight: 600;"
                      >
                        {{ data.beneficiario }}
                      </div>
                      <div class="func-status-card-label">
                        {{ contratoLabel }}
                      </div>
                    </div>

                    <div>
                      <div
                        :style="beneficiarioIconeStyle"
                        class="circle"
                      >
                        <div class="abreviatura">
                          {{ beneficiarioAbreviacao }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="nomeSolicitante"
                    class="func-status-card-solitante"
                  >
                    <div class="func-status-card-label">
                      SOLICITADO POR:
                    </div>
                    <div class="func-status-card-valor">
                      {{ nomeSolicitante }}
                    </div>
                  </div>
                </div>
              </StatusCard>

              <div style="width: 100%;">
                <ListaFormalarioSolicitacao
                  v-for="(solicitacao, index) of data.solicitacoes"
                  :key="index"
                  :solicitacao="solicitacao"
                  style="margin-bottom: 10px;"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane label="Conversa" name="conversa" v-if="data.tipo_ocorrencia_modo_visualizacao===3">
              <HistoricoChat :numeroProtocolo="data.protocolo"></HistoricoChat>
            </el-tab-pane>
            <el-tab-pane label="Conversa" name="conversa-interna" v-if="data.tipo_ocorrencia_modo_visualizacao===4">
              <ConversaHistory :protocolo="data.protocolo"></ConversaHistory>
            </el-tab-pane>
            <el-tab-pane label="Histórico" name="historico">
              <HistoricoOcorrencia :idOcorrencia="this.idOcorrencia"></HistoricoOcorrencia>
            </el-tab-pane>
            <el-tab-pane
              v-for="aba in abasAtendimento"
              :key="aba.id"
              :label="aba.descricao"
              :name="aba.id"
            >
              <div style="width: 100%;">
                <ListaFormalarioSolicitacao
                  :solicitacao="aba"
                  hidden-title
                  style="margin-bottom: 10px;"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>

        <el-col
          id="func-actions"
          :span="10"
          class="func-actions"
        >
          <div class="func-action-box">
            <div class="func-action-box-protocolo">
              <div class="func-action-box-protocolo-label">
                PROTOCOLO
              </div>
              <div class="func-action-box-protocolo-valor">
                <span>{{ data.protocolo }}</span>

                <el-popover
                  placement="bottom"
                  trigger="click"
                  width="60"
                >
                  <div style="text-align: center">
                    Copiado!
                  </div>
                  <div
                    slot="reference"
                    class="func-action-box-protocolo-valor-copy"
                    @click="clipboardCopy(data.protocolo)"
                  >
                    <svgIcone icone="icon_btn_copy"/>
                  </div>
                </el-popover>
              </div>
            </div>
            <!--          // TODO: Não achei datasource, nem no mobile-->
            <div
              v-if="false"
              class="func-action-box-protocolo"
              style="margin-top: 15px;"
            >
              <div class="func-action-box-protocolo-label">
                N. GUIA
              </div>
              <div class="func-action-box-protocolo-valor">
                <span>{{ data.protocolo }}</span>

                <el-popover
                  content="Copiado!"
                  placement="bottom"
                  trigger="click"
                >
                  <div
                    slot="reference"
                    class="func-action-box-protocolo-valor-copy"
                    @click="clipboardCopy(data.protocolo)"
                  >
                    <SvgIcone icone="icon_btn_copy"/>
                  </div>

                </el-popover>
              </div>
            </div>
          </div>

          <div
            v-if="observacao"
            class="func-action-obs-form"
          >
            <ListaFormularioCard
              :client-key="clientKey"
              :id-data="observacao.idData"
              :id-form="observacao.idForm"
              aberto
            />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import StatusCard from '@/components/cards/StatusCard'
import moment from 'moment'
import { formatAbreviatura, formatBeneficiarios, getCorAleatoria } from '@/components/GrupoFamiliar/GrupoFamiliarHelpers'
import ListaFormalarioSolicitacao from '@/components/TemplateSolicitacao/componentes/ListaFormalarioSolicitacao'
import ListaFormularioCard from '@/components/TemplateSolicitacao/componentes/ListaFormularioCard'
import HistoricoOcorrencia from '@/components/HistoricoOcorrencia/HistoricoOcorrencia'
import HistoricoChat from '@/components/HistoricoChat/HistoricoChat'
import ConversaHistory from '@/components/TemplateSolicitacao/componentes/ConversaHistory.vue'

export default {
  name: 'SolicitacaoDetalhe',
  components: {
    ListaFormularioCard,
    ListaFormalarioSolicitacao,
    StatusCard,
    HistoricoOcorrencia,
    HistoricoChat,
    ConversaHistory
  },
  data () {
    return {
      loading: false,
      data: null,
      activeTab: 'dados'
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao']),
    ...mapGetters('Login', ['beneficiarios', 'chaveUnica', 'nomeUsuario', 'contratos']),
    ...mapState('SetupApp', ['funcionalidade', 'apiSolicitacao']),
    clientKey () {
      return this.aplicacao.clientKey
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.tituloTelaDetalhe
    },
    idOcorrencia () {
      return this.$route.query.idOcorrencia
    },
    idRegistro () {
      return this.$route.query.idRegistro
    },
    dataSolicitacao () {
      const value = this.data.data_registro
      if (!value) {
        return '-'
      }
      return moment(Number.parseInt(value)).format('DD/MM/YYYY')
    },
    contratoLabel () {
      return this.data.numero_contrato_solicitacao
    },
    beneficiarioIconeStyle () {
      return {
        background: (this.beneficiario || {}).cor || getCorAleatoria()
      }
    },
    nomeSolicitante () {
      if (
        this.data.identificador_solicitante &&
        this.data.identificador_solicitante !== this.data.identificador_beneficiario
      ) {
        return this.data.solicitante
      }

      return null
    },
    beneficiarioAbreviacao () {
      return (this.beneficiario || {}).abreviacao
    },
    beneficiario () {
      if (!this.data) {
        return {}
      }

      if (!this.data.identificador_beneficiario) {
        return {}
      }

      let benefData = {}

      if (this.data.identificador_beneficiario === this.chaveUnica) {
        benefData = {
          nome: this.nomeUsuario,
          abreviacao: formatAbreviatura(this.nomeUsuario),
          matricula: '',
          chaveUnica: this.chaveUnica,
          tipoBeneficiario: '',
          cor: getCorAleatoria(),
          foto: '',
          numeroContrato: '',
          beneficiarioDados: {},
          contrato: {}
        }
      }

      if (this.beneficiarios && this.data.numero_contrato_solicitacao && this.data.perfil_usuario_chave === 'beneficiario') {
        const beneficiarios = formatBeneficiarios(
          [{ chaveUnica: this.data.identificador_beneficiario }],
          this.beneficiarios,
          { numeroContrato: this.data.numero_contrato_solicitacao }
        )

        benefData = beneficiarios[0]
      }

      return benefData || {}
    },
    observacao () {
      return null
    },
    abasAtendimento () {
      if (!this.data || !Array.isArray(this.data.abasAtendimento) || this.data.abasAtendimento.length < 1) {
        return []
      }
      return this.data.abasAtendimento
    }
  },
  methods: {
    async init () {
      await this.getDetalhe()
    },
    async getDetalhe () {
      if (this.idOcorrencia || this.idRegistro) {
        const response = await this.apiSolicitacao.detalheSolicitacao({
          headers: {
            id_funcionalidade: (this.funcionalidade || {}).idFuncionalidade,
            id_ocorrencia: this.idOcorrencia || this.idRegistro
          },
          loading: true,
          handlerErrorIgnore: true
        })
        this.data = response.data
      }
    },
    clipboardCopy (valor) {
      this.$clipboard(valor)
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="less">
.func-detalhe {
  padding: 0 20px;

  .func-infos {
    padding-right: 40px;

    .func-status-card {
      width: 100%;
      padding: 1px;
    }

    .func-status-card-beneficiario {
      display: flex;
      flex-flow: row nowrap;
      width: 100%;
    }

    .func-status-card-solitante {
      border-top: 1px dashed #AAAAAA;
      margin-top: 15px;
      padding-top: 15px;
    }

    .func-status-card-titulo {
      font: normal normal 600 18px/24px Open Sans;
      letter-spacing: 0;
      color: #333333;
    }

    .func-status-card-content {
      display: flex;
      flex-flow: row wrap;

      .form-status-card-info {
        width: 50%;
        margin-top: 10px;
      }
    }

    .func-status-card-label {
      font: normal normal normal 11px/15px Open Sans;
      letter-spacing: 0;
      color: #555555;
      word-spacing: 5px;
    }

    .abreviatura {
      font-size: 17px;
      color: #FFFFFF;
    }

    .circle {
      height: 35px;
      width: 35px;
      border-radius: 17px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .func-actions {

    .func-action-box {
      background: #F6F6F6 0 0 no-repeat padding-box;
      border-radius: 6px;
      padding: 15px;

      .func-action-box-protocolo {

        .func-action-box-protocolo-label {
          font: normal normal normal 11px/15px Open Sans;
          letter-spacing: 0;
          color: #555555;
          text-transform: uppercase;
          margin-bottom: 2px;
        }

        .func-action-box-protocolo-valor {
          font: normal normal 600 18px/24px Open Sans;
          letter-spacing: 0;
          color: #006FB9;
          display: flex;
          flex-flow: row nowrap;
          width: 100%;

          > span {
            flex: 1;
          }

          .func-action-box-protocolo-valor-copy {
            cursor: pointer;
            float: right;
          }
        }
      }
    }

    .func-action-obs-form {
      margin-top: 15px;
    }
  }
}

.border {
  border-right: solid 1px #EEEEEE;
  display: block;
  height: 100%;
  position: absolute;
  left: 56.4%;
  top: 1px;
}

.func-historico {
  padding: 20px;

  .filters {
    margin-bottom: 30px;
  }
}

.func-infos {
  padding-right: 40px;
}

/*#solicitacao-detalhe {
  .el-tabs__item {
    font: bold 14px Arial;
    color: #BBCCE0 !important;
    height: auto;
    padding: 0 20px 5px 0;
    outline: none;

    &.is-active {
      color: #1074FF !important;
    }
  }
}*/
</style>
